/*
 * File: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice\src\Content\Root\Root.tsx
 * Project: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice
 * Created Date: Tuesday June 6th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday, 30th November 2023 11:46:32
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { Fragment } from 'react';
// import Footer from 'Content/Footer/Footer';
import Header from 'Content/Header/Header';
import Main from 'Content/Main/Main';
import Styles from 'Content/Root/Root.module.css';
import { AuthProvider } from 'Router/AuthProvider';
import { ScrollRestoration, useLocation } from 'react-router-dom';
import RouterPathResolver from 'Config/Router/RouterPathResolver';

function Root(props: {children: React.ReactNode[]}) {
    const location = useLocation();

    return(
        <Fragment>
            <AuthProvider >

            <div className={`${Styles.view}`}>
                {
                   RouterPathResolver.pathLogin.path !== location.pathname ? <Header /> : null
                }
                <Main />
                {/* <Footer /> */}
            </div>
            </AuthProvider >
            <ScrollRestoration />
        </Fragment>
    );
}

export default Root;
